import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "17",
  fill: "none",
  viewBox: "0 0 13 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M2.698.75h7.5m-3.75 9.375v6.042M3.875.75h5.146v5s3.091.823 3.125 4.375H.75C.784 6.573 3.875 5.75 3.875 5.75z"
    }, null, -1)
  ]))]))
}
export default { render: render }